import React from 'react';
import BaseDealFormDialog from '@/modules/deals/shared/components/BaseDealFormDialog';

const CreateInProgressDealDialog = ({
  isOpen,
  onClose,
  onCreate,
  stages,
  staff,
  staffCatalogStatus,
  clients,
}) => {
  return (
    <BaseDealFormDialog
      isOpen={isOpen}
      onClose={onClose}
      onCreate={onCreate}
      dealType="inCorso"
      stages={stages}
      staff={staff}
      staffCatalogStatus={staffCatalogStatus}
      clients={clients}
    />
  );
};

export default CreateInProgressDealDialog;
